import { useParams } from "react-router-dom"
import FeatureStatesProvider from "./providers/FeatureStatesProvider"
import FeatureMapView from "./components/FeatureMapView"
import FeatureListView from "./components/FeatureListView"


const GeoFeature = () => {
    const { tab_name } = useParams()
    if (!tab_name) return null

    return (
        <FeatureStatesProvider>
            {tab_name === 'Feature_map' ? <FeatureMapView /> : <FeatureListView />}
        </FeatureStatesProvider>
    )
}

export default GeoFeature